import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from 'react-zoom-pan-pinch';
import './PregledSlikaPopup.css';
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
// import PdfViewer from '../PregledPdf/PDFViewer';

const Controls = ({ selectedImg }) => {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  const handleDownload = () => {
    if (selectedImg) {
      const link = document.createElement('a');
      link.href = selectedImg;
      link.download = 'captured_image.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    // Za koriscenje zoom-a na klik
    <div
      style={{
        position: 'fixed',
        top: '10px',
        left: '48%',
        transform: 'translateX(-50%)',
        zIndex: 1100,
        alignItems: 'cente',
      }}
    >
      <button onClick={() => zoomIn()}>Zoom In</button>
      <button onClick={() => zoomOut()}>Zoom Out</button>
      <button onClick={() => resetTransform()}>Reset</button>
      <button onClick={handleDownload}>Download</button>
    </div>
  );
};

export default function PregledSlikaPopupUniverzalno({
  selectedImg,
  setSelectedImg,
}) {
  // console.log(selectedImg);
  // const iframet = 'data:application/pdf;base64,' + selectedImg;
  const popupRef = useRef(null);
  const handleClick = () => {
    setSelectedImg(null);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation(); // Sprečava propagaciju ka globalnim handlerima
        setSelectedImg(null);
      }
    };

    const currentPopup = popupRef.current;

    if (currentPopup) {
      currentPopup.focus(); // Osigurava da popup ima fokus
      currentPopup.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      if (currentPopup) {
        currentPopup.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, [setSelectedImg]);
  return selectedImg
    ? createPortal(
        <>
          <div
            onClick={handleClick}
            style={{
              position: 'fixed',
              right: '20px',
              top: '10px',
              color: 'white',
              fontSize: '40px',
              fontWeight: 'bold',
              zIndex: '1501',
              cursor: 'pointer',
            }}
          >
            X
          </div>
          <div
            ref={popupRef}
            className="backdropSlike"
            tabIndex={-1}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <TransformWrapper>
              <Controls
                selectedImg={selectedImg}
                setSelectedImg={setSelectedImg}
              />
              <TransformComponent>
                <img
                  className="img_prikazSlike"
                  src={selectedImg}
                  alt="slika"
                />
              </TransformComponent>
            </TransformWrapper>
          </div>
        </>,
        document.body, // 👈 Ovde ide renderovanje
      )
    : null;
}
